import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, throwError } from 'rxjs';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';

import { NotifyService } from '@fry/lib/utils';

import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { SecurityService } from '@fry/lib/security';


@Component({
    selector: 'eas-editor-booking-item-tree-edit',
    templateUrl: './editor-booking-item-tree-edit.component.html',
    styleUrls: ['./editor-booking-item-tree-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemTreeEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private notify: NotifyService,
    private security: SecurityService,
    private itemTreeStore: EditorBookingItemTreeStore
  ) {

  }

  ngOnInit() {
    this.route.data.pipe(
      takeUntil(this.destroyed$),
      switchMap(data => {
        let securityContext = data.bookingItem.doc?.securityContext ?? { roles: [] };
        return this.security.hasPermission('bookingItems.edit', securityContext).pipe(
          map(has => {
            if (!has) {
              throw new Error($localize `You do not have permission to edit this booking item`);
            }
            return data;
          })
        )
      }),
      catchError(error => {
        this.notify.error(error);
        return throwError(() => error);
      }),
    ).subscribe(data => {
      this.itemTreeStore.initializeFromBookingItem(data.bookingItem);
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
